export default __webpack_public_path__ + "b7f20db11e32da58d6ad92f0d89672be.png";